import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Button } from '..';
import styles from './nav.module.scss';

const TranslateLink = (props) => {
  const { formatMessage, locale } = useIntl();
  const accessibleLabel = formatMessage({
    id: 'nav.translate',
    defaultMessage: 'View this page in English',
  });

  return (
    <Button
      link
      underline
      className={cn(styles.navLink, props.className)}
      ariaLabel={accessibleLabel}
      onClick={props.onClick}
    >
      {locale === 'en' ? 'Français' : 'English'}
    </Button>
  );
};

TranslateLink.propTypes = {
  /** The callback function called when the language switch button is clicked */
  onClick: PropTypes.func,
  /** A custom classname for the button */
  className: PropTypes.string,
};

TranslateLink.defaultProps = {
  onClick: undefined,
};

export default TranslateLink;
